import type { Membership } from '@rp/contracts'
import { Button, Chip } from '../design'
import { SESSION_COPY } from './copy'

export const TenantPicker = ({
  memberships,
  onChoose,
  onSignOut,
}: {
  memberships: readonly Membership[]
  onChoose: (tenantId: string) => void
  onSignOut: () => void
}) => (
  <div className="entry tenant-picker">
    <div className="entry-band hatch" aria-hidden="true" />
    <main className="entry-sheet">
      <h1 className="tenant-picker-title">{SESSION_COPY.pickTenant}</h1>
      <p className="tenant-picker-hint">{SESSION_COPY.pickTenantHint}</p>
      <ul className="tenant-picker-list">
        {memberships.map((membership) => (
          <li key={membership.tenantId}>
            <Button className="tenant-option" onClick={() => onChoose(membership.tenantId)}>
              <span className="tenant-option-name">{membership.tenantName}</span>
              <Chip>{SESSION_COPY.roleLabels[membership.role]}</Chip>
            </Button>
          </li>
        ))}
      </ul>
      <div className="tenant-picker-foot">
        <Button variant="ghost" onClick={onSignOut}>
          {SESSION_COPY.signOut}
        </Button>
      </div>
    </main>
  </div>
)
